import React from 'react';

const Dismiss = ({ onClick, size = 'large' }) => {
    return <button className="dismiss" onClick={onClick}>
        <span className={`dismiss__icon dismiss__icon--${size}`}>&nbsp;</span>
    </button>
};

export default Dismiss;